import { loadSprites } from '../engine/assetLoader';
import { Renderable } from '../engine/renderable';
import Vector2d from '../engine/vector2d';
import State from '../state';
import { getScores, HiScoreEntry } from '../store';
import TextRenderer, { Color, FontSize } from '../text';

import { RenderableScreen, Screen, ScreenManager } from './screenManager';

const getPrefix = (index: number) => (
  index === 0 ? '1st' :
  index === 1 ? '2nd' :
  index === 2 ? '3rd' :
  index === 3 ? '4th' :
  index === 4 ? '5th' :
  ''
 );

const getColor = (index: number) => (
  index === 0 ? Color.Red :
  index === 1 ? Color.Yellow :
  index === 2 ? Color.Green :
  index === 3 ? Color.Cyan :
  index === 4 ? Color.Blue :
  Color.Purple
);

export default class HighScoreScreen implements RenderableScreen {
  name = 'HighScoreScreen';

  private readonly width: number;
  private readonly height: number;
  private readonly screenManager: ScreenManager;

  private gameObjects: Renderable<State>[] = [];
  private textRenderer: TextRenderer | undefined;
  private highScores: HiScoreEntry[] | undefined;

  constructor(screenManager: ScreenManager) {
    this.screenManager = screenManager;
    this.width = screenManager.width;
    this.height = screenManager.height;
  }

  onPlayerInput(): void {
    this.screenManager.setScreen(Screen.Game);
  }

  initScreen(state: State): void {
    this.highScores = getScores().map(s => ({
      ...s,
      isNew: Date.now() - s.timestamp < 10000
    }));

    state.reset();
    this.gameObjects = [];

    loadSprites([
      'font'
    ])
      .then(sprites => {
        this.textRenderer = new TextRenderer(sprites.find(s => s.name === 'font'));
        this.update(0, state);
      });
  }

  update(gameTime: number, state: State): void {
    if (gameTime % 2 === 0) {
      this.gameObjects.forEach(obj => obj.update(gameTime, state));
    }
  }


  render(_: State, gameTime: number, ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, this.width, this.height);

    this.textRenderer?.renderText(`Hi score!`, FontSize.Large, Color.White, new Vector2d(25.5, 4), ctx);

    this.highScores?.forEach((entry, i) => {
      if (!entry.isNew || (gameTime % 30 < 15))
      this.textRenderer?.renderText(
        `${getPrefix(i)} ${entry.name.substr(0, 20).padEnd(20, ' ')}  ${entry.score.toString().padStart(7, ' ')}`,
        FontSize.Large,
        getColor(i),
        new Vector2d(7, 10 + (i * 4)), ctx
      );
    });

    this.textRenderer?.renderText(`Press any button`, FontSize.Normal, Color.Cyan, new Vector2d(24, 32), ctx);

    ctx.save();
  }
}
